import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, setBlockTracking as _setBlockTracking, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ingress-cards" }
const _hoisted_2 = { class: "ingress-card-sub-header" }
const _hoisted_3 = { class: "mmt-2" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "sr-only" }

import { _CREATE, _VIEW } from '@shell/config/query-params';
import { PropType } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import { RcItemCard, RcItemCardAction } from '@components/RcItemCard';

interface IngressCard {
  id: string;
  image?: any;
  header: { title: { key: string } };
  subHeader: { label: { key: string } };
  content: { key: string };
  doc?: {url: string};
  selected?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IngressCards',
  props: {
  options: {
    type:     Array as PropType<IngressCard[]>,
    required: true
  },
  mode: { type: String, default: _CREATE },
},
  emits: ['select'],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const store = useStore();
const { t } = useI18n(store);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (card) => {
      return (_openBlock(), _createBlock(_unref(RcItemCard), {
        id: card.id,
        key: card.id,
        header: card.header,
        image: card.image,
        content: card.content,
        selected: card.selected,
        variant: "small",
        role: "link",
        disabled: __props.mode === _unref(_VIEW),
        class: _normalizeClass({ 'single-card': __props.options.length === 1 }),
        clickable: __props.mode !== _unref(_VIEW),
        onCardClick: ($event: any) => (emit('select', card.id))
      }, _createSlots({
        "item-card-sub-header": _withCtx(() => [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)(card.subHeader.label.key)), 1)
        ]),
        _: 2
      }, [
        (!!card.doc)
          ? {
              name: "item-card-footer",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(RcItemCardAction), null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: card.doc.url,
                        rel: "nofollow noopener noreferrer",
                        target: "_blank",
                        class: "ingress-card-footer-button secondary-text-link"
                      }, [
                        _createTextVNode(_toDisplayString(_unref(t)('cluster.ingress.learnMore.label')) + " ", 1),
                        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icon icon-external-link" }, null, -1)),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('generic.opensInNewTab')), 1)
                      ], 8, _hoisted_4)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["id", "header", "image", "content", "selected", "disabled", "class", "clickable", "onCardClick"]))
    }), 128))
  ]))
}
}

})